// Module-name keys used to look up permissions in the admin user's roleDetails.
// Values must match the `module` field in
// daaisaasserver/daai/config/adminPermissionCatalog.js exactly — that is the
// single source of truth.
export const admin_module_names = {
  dashboard_module: 'Dashboard',
  customer_management_module: 'Customers',
  leads_module: 'Leads',
  subscription_plan_management_module: 'SubscriptionPlans',
  order_management_module: 'Orders',
  broadcast_management_module: 'Broadcasts',
  reports_module: 'Reports',
  referrals_module: 'Referrals',
  setting_module: 'Settings',
  support_ticket_module: 'SupportTickets',
  admin_users_module: 'AdminUsers',
  roles_module: 'Roles',
};
